import React, { createContext, useContext } from 'react';
import useAuth from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { useEarlyAccess } from './EarlyAccessContext';

const PILOT_MESSAGE = "Thanks. We're onboarding a limited set of users during beta. We'll reach out soon.";

const PilotAccessContext = createContext(null);

export function PilotAccessProvider({ children }) {
  const { pilotWhitelisted } = useAuth();
  const navigate = useNavigate();
  const { openEarlyAccessModal } = useEarlyAccess();

  const isPilotAllowed = pilotWhitelisted;

  const showPilotMessage = (options = {}) => {
    const { redirectTo = '/', source } = options; // source: 'pulse' | 'radar' | 'designer'
    openEarlyAccessModal(source);
    if (redirectTo) {
      navigate(redirectTo);
    }
  };

  const handlePremiumClick = (e, targetPath) => {
    if (!isPilotAllowed) {
      e?.preventDefault?.();
      e?.stopPropagation?.();
      showPilotMessage({ redirectTo: null });
      return false;
    }
    return true;
  };

  return (
    <PilotAccessContext.Provider value={{
      isPilotAllowed,
      showPilotMessage,
      handlePremiumClick,
      pilotMessage: PILOT_MESSAGE
    }}>
      {children}
    </PilotAccessContext.Provider>
  );
}

export function usePilotAccess() {
  const ctx = useContext(PilotAccessContext);
  return ctx ?? {
    isPilotAllowed: true,
    showPilotMessage: () => {},
    handlePremiumClick: () => true,
    pilotMessage: PILOT_MESSAGE
  };
}
